import Navbar from "@/components/HomeNavBar/HomeNavBar.vue"
import AllPortals from "@/components/GetPortals/PortalsComponent.vue"
import CreateFeed from "@/components/CreateFeed/CreateFeed.vue"
import PortalMembers from "@/components/PortalMembers/PortalMembers.vue";
import PortalRequest from "@/components/GetPortalRequest/PortalRequestView.vue"
import SurveyView from "@/components/SurveysAndPolls/Survey.vue";
import DocumentApproval from "@/components/DocumentApproval/DocumentApproval.vue";
import DocumentWarehouse from "@/components/DocumentWarehouse/DocumentWarehouse.vue";
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue"
import CreateTagCategory from "@/components/CreateTagCategory/CreateTagCategoryView.vue";
import ApprovalPublishingPost from "@/components/ApprovalPublishingPost/ApprovalPost.vue";
import ReportCommentModal from "@/components/ReportCommentModal/ReportCommentModal.vue";
import CreateSubject from "@/components/CreateSubject/CreateSubject.vue";
import AllSubjects from "@/components/GetSubjects/SubjectComponent.vue";

import axios from "axios";

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import {get_token , get_user_details } from "@/router";
import { client_domain } from "@/main.js";

/* global Masonry */

export default {
  components: {
    Multiselect,
    Navbar,
    AllPortals,
    CreateFeed,
    PortalMembers,
    PortalRequest,
    SurveyView,
    DocumentApproval,
    DocumentWarehouse,
    StickyNav,
    CreateTagCategory,
    ApprovalPublishingPost,
    ReportCommentModal,
    CreateSubject,
    AllSubjects
  },
  data() {
    return ({
      activeVoiceTab: 'your_feed',
      reports: [],
      expandedReports: [],
      token_exists: false,
      edit_report_id: null,
      edit_report_description: '',
      edit_documents: [],
      user_details: {
        "user_role": '',
        "user_id": null,
      },
      is_report_loading: false,
      hasLoadedOnce: false,
      activeTab: 'category',
      selectedCategory: 'all',
      selectedTag: 'all',
      categories: [],
      tagOptions: [],
      categoryOptions: [],
      all_tags_by_category: new Map(),
      search_query: '',
      selectedFilters: new Map(),
      dwypd_domain: false,
      temporaryPost: null,
      editFileName: '',
      selected_categories: [],
      showMobileCategories: false,
      validTagIds: {},
      comment_modal_visible: false,
      report_data: {},
      likedReports: JSON.parse(localStorage.getItem("likedReports") || "{}"),
      preloadedReports: [],
      page: 1,
      page_size: 4,
      hasMore: false,



    });
  },
  watch: {
    '$route.params.portal_id'() {
      this.filterReports();
    },
    activeTab(newTab) {
    if (newTab === 'category') {
      this.setCategoryOptions();
      this.selectedCategory = 'all';      // Reset selected category
      this.tagOptions = [];               // Clear tags
      this.selectedTag = 'all';           // Reset selected tag
    }
  },

  selectedCategory(newCategory) {
    this.selectedCategory = newCategory;
    if (newCategory === 'all') {
      this.tagOptions = [];               // Keep tags empty when no category selected
      this.selectedTag = 'all';
    } else {  // Load tags for that category
      this.selectedTag = 'all';
    }
  }
  },
  created() {
  this.filterReports()
},
  mounted() {
    this.$nextTick(() => this.loadMasonry());
    this.token_exists = get_token();
    this.user_details = get_user_details();

    if (client_domain.includes('dwypd') || client_domain.includes('soulcity') || client_domain.includes('nsp')) {
      this.dwypd_domain = true;
    }
  },
   updated() {
    this.$nextTick(() => this.loadMasonry());
  },
  computed: {
filtered_reports() {

  return this.reports
    // 1. Only include reports visible to the current user
    .filter(report => this.is_visible_report(report))
    .filter(report =>
      report?.status?.name === 'pending'
    )
}


  },
  methods: {


  display_comment_modal(data) {
  this.report_data = data;
  this.comment_modal_visible = true;
},


    handleScroll() {
    const container = this.$refs.scrollContainer;
    if (!container) return;

    const scrollBottom = container.scrollTop + container.clientHeight;
    if (scrollBottom >= container.scrollHeight - 50) { // near bottom
      this.filterReports();
    }
  },
    is_visible_report(report) {
  if (!report || !this.user_details) {
    return false;
  }

  const is_admin = this.user_details.user_role === 'admin';
  const is_creator = String(report.base_profile?.user?.id) === String(this.user_details.user_id);
  const is_approved = report.status?.name === 'pending';

  // Only admins, creators, or approved reports are visible
  return is_admin || is_creator || is_approved;
},
    getToken() {
      return get_token();
    },
    processPortalReports(results) {


  // Prevent duplicates if needed
  const newReports = results.filter(r => !this.reports.some(existing => existing.id === r.id));
  this.reports.push(...newReports);
},

async filterReports() {
  if (this.is_report_loading) return;

  this.is_report_loading = true;
  const portal_id = this.$route.params.portal_id;
  const report_id = this.$route.query.report_id;
  const headersConfig = {
    headers: {
      Authorization: `Token ${this.getToken()}`,
      'Content-Type': 'application/json',
    },
  };

  try {
    let results;

    // 1️⃣ Use preloaded reports if available
    if (this.preloadedReports.length) {
      results = this.preloadedReports;
      this.preloadedReports = [];
      this.page += 1;
    } else {
      // 2️⃣ Normal fetch
      const res = await axios.post(
        `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_portal/`,
        { portal_id, page: this.page, page_size: this.page_size },
        headersConfig
      );

      if (res.data.status === 'success' && res.data.report_data) {
        results = res.data.report_data.results || [];
        this.hasMore = res.data.report_data.has_more;
        this.page = res.data.report_data.page + 1;
      }
    }

    // 3️⃣ Process the results
    if (results.length) this.processPortalReports(results);

    // 4️⃣ Preload next page in background
    if (this.hasMore) this.preloadPortalReports(portal_id);

    // 5️⃣ Open modal if report_id is passed
    if (report_id) {
      const selectedReport = this.reports.find(r => r.id == report_id);
      if (selectedReport) {
        this.display_comment_modal(selectedReport);
      }
    }

  } catch (error) {
    console.error('Error fetching reports:', error.response?.data || error.message);
  } finally {
    this.is_report_loading = false;
    this.hasLoadedOnce = true;
  }
},

async preloadPortalReports(portal_id) {
  const headersConfig = {
    headers: {
      Authorization: `Token ${this.getToken()}`,
      'Content-Type': 'application/json',
    },
  };
  try {
    const res = await axios.post(
      `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_portal/`,
      { portal_id, page: this.page, page_size: this.page_size },
      headersConfig
    );

    if (res.data.status === 'success' && res.data.report_data) {
      this.preloadedReports = res.data.report_data.results || [];
      this.hasMore = res.data.report_data.has_more;
    }
  } catch (error) {
    console.error('Error preloading reports:', error.response?.data || error.message);
    this.preloadedReports = [];
  }
},
    isPDF(url) {
      return /\.pdf$/i.test(url);
    },
    isVideo(url) {
      return /\.(mp4|webm|ogg)$/i.test(url);
    },
    isAudio(url) {
      return /\.(mp3|wav|ogg)$/i.test(url);
    },
    isDoc(url) {
      return /\.(doc|docx|ppt|pptx|xls|xlsx|html|htm)$/i.test(url);
    },
    toggle_description(reportId) {
      const index = this.expandedReports.indexOf(reportId);
      if (index > -1) {
        this.expandedReports.splice(index, 1);
      } else {
        this.expandedReports.push(reportId);
      }
      this.$nextTick(() => this.loadMasonry());
    },
      get_description(report) {
        if (!report.description) return '';

        // Use DOMParser to safely parse HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(report.description, 'text/html');

        // Remove all <img> tags
        doc.querySelectorAll('img').forEach(img => img.remove());

        const textOnly = doc.body.textContent.trim();

        if (this.expandedReports.includes(report.id) || textOnly.length <= 250) {
          return textOnly;
        }

        return textOnly.substring(0, 250) + '...';
      },

    getFileIcon(fileUrl) {
      const iconMap = [
        { extensions: ['.pdf'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337946.png' },
        { extensions: ['.doc', '.docx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337932.png' },
        { extensions: ['.xls', '.xlsx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337958.png' },
        { extensions: ['.ppt', '.pptx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337950.png' },
        { extensions: ['.html', '.htm'], icon: 'https://cdn-icons-png.flaticon.com/128/732/732212.png' },
      ];

      for (const { extensions, icon } of iconMap) {
        if (extensions.some(ext => fileUrl.includes(ext))) {
          return icon;
        }
      }

      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
    }
    ,
    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },

     getCardSize(index) {
      // Ensure index is a valid number
      if (
        typeof index !== 'number' ||
        !Number.isInteger(index) ||
        index < 0 ||
        index >= this.filtered_reports.length
      ) {
        return '';
      }

      const report = this.filtered_reports.at(index);
      const descriptionLength = report?.description?.length || 0;

      if (descriptionLength > 500) return 'feature';
      if (index === 0) return '';
      if (index % 5 === 0) return 'tall';
      return '';
    },


    approve_report(report_id) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, approve it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/approve_published_report/`,
            data: JSON.stringify({
              report_id: report_id,
              user_id: this.user_details.user_id
            }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.reports = this.reports.map(report =>
                  report.id === report_id ? { ...report,
                    status: { ...report.status || {}, name: "approved" }} : report
                )
                Swal.fire({
                  title: 'Approved!',
                  text: 'The report has been approved.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                });
              } else {
                Swal.fire({
                  title: 'Failed!',
                  text: response.message || 'An error occurred. Please try again.',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            },
            error: () => {
              Swal.fire({
                title: 'Failed!',
                text: 'An error occurred. Please try again.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },
    reject_report(report_id) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, reject it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/reject_published_report/`,
            data: JSON.stringify({
              report_id: report_id,
              user_id: this.user_details.user_id
            }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.reports = this.reports.map(report =>
                  report.id === report_id ? { ...report,
                    status: { ...report.status || {}, name: "rejected" }} : report
                )
                Swal.fire({
                  title: 'Rejected!',
                  text: 'The report has been rejected.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                });
              } else {
                Swal.fire({
                  title: 'Failed!',
                  text: response.message || 'An error occurred. Please try again.',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            },
            error: () => {
              Swal.fire({
                title: 'Failed!',
                text: 'An error occurred. Please try again.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },
    loadMasonry() {
      if (!this.$refs.masonryGrid) return;

      new Masonry(this.$refs.masonryGrid, {
        itemSelector: ".masonry-item",
        percentPosition: true,
        gutter: 16,
      });
  },
  getQuillImages(report) {
    if (!report.description) return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(report.description, 'text/html');

    const imgs = Array.from(doc.querySelectorAll('img'));
    return imgs.map(img => img.src);
  },

  }
  }